import React, { useState, useEffect } from 'react';
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    CardMedia,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Chip,
    Paper,
    InputAdornment,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsVolleyballIcon from '@mui/icons-material/SportsVolleyball';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import SportsMartialArtsIcon from '@mui/icons-material/SportsMartialArts';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

const Events = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedSport, setSelectedSport] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [showFavoritesOnly, setShowFavoritesOnly] = useState(false);
    const location = useLocation();

    // Faire défiler vers le haut de la page quand la route change
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const allEvents = [
        {
            id: 1,
            title: 'Football Match - Liga 1',
            description: 'Alianza Lima vs Universitario de Deportes - Peruvian football classic',
            date: 'December 15, 2024',
            time: '20:00',
            location: 'Estadio Nacional, Lima',
            city: 'Lima',
            image: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=400&h=250&fit=crop',
            sport: 'Football',
            price: '50-150 PEN',
            category: 'Match',
            icon: <SportsSoccerIcon />,
        },
        {
            id: 2,
            title: 'Basketball Championship',
            description: 'National basketball championship final',
            date: 'December 20, 2024',
            time: '19:30',
            location: 'Coliseo Eduardo Dibós, Lima',
            city: 'Lima',
            image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400&h=250&fit=crop',
            sport: 'Basketball',
            price: '30-80 PEN',
            category: 'Final',
            icon: <SportsBasketballIcon />,
        },
        {
            id: 3,
            title: 'Volleyball Tournament',
            description: "International women's volleyball competition",
            date: 'December 25, 2024',
            time: '18:00',
            location: 'Coliseo Mariscal Cáceres, Lima',
            city: 'Lima',
            image: 'https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=400&h=250&fit=crop',
            sport: 'Volleyball',
            price: '25-60 PEN',
            category: 'International',
            icon: <SportsVolleyballIcon />,
        },
        {
            id: 4,
            title: 'Cusco Tennis Open',
            description: 'Clay court tennis tournament in the imperial city',
            date: 'January 10, 2025',
            time: '14:00',
            location: 'Cusco Tennis Club',
            city: 'Cusco',
            image: 'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=400&h=250&fit=crop',
            sport: 'Tennis',
            price: '40-100 PEN',
            category: 'Tournament',
            icon: <SportsTennisIcon />,
        },
        {
            id: 5,
            title: 'Sporting Cristal vs Melgar',
            description: 'Clash between two Peruvian football giants',
            date: 'January 18, 2025',
            time: '21:00',
            location: 'Estadio Alberto Gallardo, Lima',
            city: 'Lima',
            image: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?w=400&h=250&fit=crop',
            sport: 'Football',
            price: '45-120 PEN',
            category: 'Match',
            icon: <SportsSoccerIcon />,
        },
        {
            id: 6,
            title: 'Karate Championship',
            description: 'National traditional karate competition',
            date: 'January 22, 2025',
            time: '16:00',
            location: 'Coliseo Arequipa',
            city: 'Arequipa',
            image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=250&fit=crop',
            sport: 'Martial Arts',
            price: '20-50 PEN',
            category: 'Championship',
            icon: <SportsMartialArtsIcon />,
        },
        {
            id: 7,
            title: 'University Basketball',
            description: 'Match between San Marcos and La Molina universities',
            date: 'January 28, 2025',
            time: '20:30',
            location: 'Coliseo de la UNMSM, Lima',
            city: 'Lima',
            image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=250&fit=crop',
            sport: 'Basketball',
            price: '15-35 PEN',
            category: 'University',
            icon: <SportsBasketballIcon />,
        },
        {
            id: 8,
            title: 'Beach Volleyball - Trujillo',
            description: 'Beach volleyball tournament on the northern coast',
            date: 'February 5, 2025',
            time: '15:00',
            location: 'Huanchaco Beach, Trujillo',
            city: 'Trujillo',
            image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=250&fit=crop',
            sport: 'Volleyball',
            price: 'Free',
            category: 'Beach',
            icon: <SportsVolleyballIcon />,
        },
    ];

    const sports = ['Football', 'Basketball', 'Volleyball', 'Tennis', 'Martial Arts'];
    const cities = ['Lima', 'Cusco', 'Arequipa', 'Trujillo', 'Piura', 'Iquitos'];

    let filteredEvents = allEvents.filter(event => {
        const matchesSearch = event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            event.description.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesSport = selectedSport === '' || event.sport === selectedSport;
        const matchesCity = selectedCity === '' || event.city === selectedCity;
        return matchesSearch && matchesSport && matchesCity;
    });
    if (showFavoritesOnly) {
        filteredEvents = filteredEvents.filter((_, idx) => idx < 2);
    }

    const getSportColor = (sport) => {
        const colors = {
            'Football': '#D91023',
            'Basketball': '#FF6B35',
            'Volleyball': '#4ECDC4',
            'Tennis': '#45B7D1',
            'Martial Arts': '#96CEB4',
        };
        return colors[sport] || '#666';
    };

    return (
        <Box sx={{ py: 4 }}>
            <Container maxWidth="xl">
                {/* Header */}
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Sports Events
                    </Typography>
                    <Typography variant="h6" color="text.secondary">
                        Discover all sports events in Peru
                    </Typography>
                </Box>

                {/* Filters */}
                <Paper elevation={3} sx={{
                    p: { xs: 2, md: 4 },
                    mb: 5,
                    borderRadius: 4,
                    background: 'rgba(255,255,255,0.97)',
                    boxShadow: '0 8px 32px rgba(255,107,107,0.10)',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 3,
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    maxWidth: 900,
                    position: 'relative',
                    zIndex: 2
                }}>
                    <TextField
                        fullWidth
                        size="small"
                        label="Search for an event"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ color: '#FF6B6B' }} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            maxWidth: 260,
                            background: 'white',
                            borderRadius: 3,
                            boxShadow: '0 2px 8px rgba(255,107,107,0.07)',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 3,
                                fontWeight: 500,
                                transition: 'box-shadow 0.3s',
                                '&.Mui-focused fieldset': {
                                    borderColor: '#FF6B6B',
                                    boxShadow: '0 0 0 2px #FF6B6B33',
                                },
                            },
                            '& label.Mui-focused': {
                                color: '#FF6B6B',
                            },
                        }}
                    />
                    <FormControl fullWidth size="small" sx={{ maxWidth: 200, background: 'white', borderRadius: 3, boxShadow: '0 2px 8px rgba(255,107,107,0.07)', '& .MuiOutlinedInput-root': { borderRadius: 3 }, '& label.Mui-focused': { color: '#FF6B6B' } }}>
                        <InputLabel>Sport</InputLabel>
                        <Select
                            value={selectedSport}
                            label="Sport"
                            onChange={(e) => setSelectedSport(e.target.value)}
                            sx={{ fontWeight: 500 }}
                        >
                            <MenuItem value="">All sports</MenuItem>
                            {sports.map((sport) => (
                                <MenuItem key={sport} value={sport}>{sport}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth size="small" sx={{ maxWidth: 200, background: 'white', borderRadius: 3, boxShadow: '0 2px 8px rgba(255,107,107,0.07)', '& .MuiOutlinedInput-root': { borderRadius: 3 }, '& label.Mui-focused': { color: '#FF6B6B' } }}>
                        <InputLabel>City</InputLabel>
                        <Select
                            value={selectedCity}
                            label="City"
                            onChange={(e) => setSelectedCity(e.target.value)}
                            sx={{ fontWeight: 500 }}
                        >
                            <MenuItem value="">All cities</MenuItem>
                            {cities.map((city) => (
                                <MenuItem key={city} value={city}>{city}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={showFavoritesOnly}
                                onChange={e => setShowFavoritesOnly(e.target.checked)}
                                sx={{ color: '#FF6B6B', '&.Mui-checked': { color: '#FF6B6B' } }}
                            />
                        }
                        label={<span style={{ fontWeight: 500 }}>Show only favorites</span>}
                        sx={{ ml: 1, minWidth: 220 }}
                    />
                </Paper>

                {/* Results count */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="h6" color="text.secondary">
                        {filteredEvents.length} event{filteredEvents.length !== 1 ? 's' : ''} found
                    </Typography>
                </Box>

                {/* Events Grid */}
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
                    gap: 2,
                }}>
                    {filteredEvents.map((event, idx) => (
                        <Card
                            key={event.id}
                            sx={{
                                m: 0,
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                borderRadius: 3,
                                overflow: 'hidden',
                                position: 'relative',
                                transition: 'all 0.3s ease-in-out',
                                '&:hover': {
                                    transform: 'translateY(-8px)',
                                    boxShadow: '0 12px 24px rgba(0,0,0,0.15)',
                                },
                            }}
                        >
                            <CardMedia
                                component="img"
                                height="200"
                                image={event.image}
                                alt={event.title}
                                sx={{ objectFit: 'cover' }}
                            />
                            <CardContent sx={{ flexGrow: 1, p: 3, display: 'flex', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <Box sx={{ color: getSportColor(event.sport), mr: 1, display: 'flex', alignItems: 'center' }}>
                                        {React.cloneElement(event.icon, { fontSize: 'small' })}
                                    </Box>
                                    <Typography variant="body2" fontWeight="bold" sx={{ color: getSportColor(event.sport), display: 'flex', alignItems: 'center' }}>
                                        {event.sport}
                                    </Typography>
                                    <Chip
                                        label={event.category}
                                        size="small"
                                        sx={{ ml: 'auto', backgroundColor: 'primary.main', color: 'white' }}
                                    />
                                </Box>

                                <Typography variant="h6" component="h3" gutterBottom sx={{ lineHeight: 1.3, textAlign: 'left' }}>
                                    {event.title}
                                </Typography>

                                <Typography variant="body2" color="text.secondary" paragraph sx={{ flexGrow: 1, mb: 2, textAlign: 'left' }}>
                                    {event.description}
                                </Typography>

                                <Box sx={{ mb: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <CalendarTodayIcon sx={{ fontSize: 16, mr: 1, color: 'text.secondary' }} />
                                        <Typography variant="body2" color="text.secondary">
                                            {event.date} at {event.time}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <LocationOnIcon sx={{ fontSize: 16, mr: 1, color: 'text.secondary' }} />
                                        <Typography variant="body2" color="text.secondary">
                                            {event.location}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                    <Typography variant="body2" fontWeight="bold" color="primary">
                                        {event.price}
                                    </Typography>
                                    <Chip label={event.city} size="small" variant="outlined" />
                                </Box>

                                <Button
                                    component={Link}
                                    to={`/event/${event.id}`}
                                    variant="contained"
                                    fullWidth
                                    sx={{ mt: 'auto' }}
                                >
                                    View details
                                </Button>
                            </CardContent>
                            {/* Icône étoile favori */}
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 10,
                                    right: 10,
                                    zIndex: 2,
                                    cursor: 'pointer',
                                    color: '#FF6B6B',
                                    background: 'white',
                                    borderRadius: '50%',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.10)',
                                    p: 0.5,
                                    width: 32,
                                    height: 32,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'box-shadow 0.2s, color 0.2s',
                                    '&:hover': {
                                        color: '#d94a4a',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.16)',
                                    },
                                }}
                                title={idx < 2 ? "Remove from favorites" : "Add to favorites"}
                            >
                                {idx < 2 ? (
                                    <StarIcon fontSize="small" />
                                ) : (
                                    <StarBorderIcon fontSize="small" />
                                )}
                            </Box>
                        </Card>
                    ))}
                </Box>

                {filteredEvents.length === 0 && (
                    <Box sx={{ textAlign: 'center', py: 8 }}>
                        <Typography variant="h6" color="text.secondary">
                            No event found with these criteria
                        </Typography>
                        <Button
                            variant="outlined"
                            onClick={() => {
                                setSearchTerm('');
                                setSelectedSport('');
                                setSelectedCity('');
                            }}
                            sx={{ mt: 2 }}
                        >
                            Reset filters
                        </Button>
                    </Box>
                )}
            </Container>
        </Box>
    );
};

export default Events; 